import { render, staticRenderFns } from "./ParcelForm.vue?vue&type=template&id=4e9da155&scoped=true&"
import script from "./ParcelForm.vue?vue&type=script&lang=ts&"
export * from "./ParcelForm.vue?vue&type=script&lang=ts&"
import style0 from "./ParcelForm.vue?vue&type=style&index=0&id=4e9da155&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9da155",
  null
  
)

export default component.exports